import { useContext } from 'react'
import { ScheduleContext, type ScheduleContextValue } from './schedule-context'

export function useSchedule(): ScheduleContextValue {
  const ctx = useContext(ScheduleContext)
  if (!ctx) throw new Error('useSchedule must be used inside <ScheduleDataProvider>')
  return ctx
}
